export class ItineraryTemplateViewModel {
  public Id: number
  public Name: string
  public MergePage: number
  public Uri: string
  public BottomMarginPoints: number
  public TopMarginPoints: number
  public Document: AttachedDocumentViewModel
}

export class AttachedDocumentViewModel {
  public Id: number
  public FileName: string
}
